class QuncelModelExplorer extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.products = JSON.parse(this.querySelector('[data-qv3-explorer-products]').textContent);
    this.tabs = this.querySelector('[data-qv3-explorer-tabs]');
    this.panel = this.querySelector('[data-qv3-explorer-panel]');
    this.activeId = 'pro';
    this.recommendation = { primary: '', secondary: '' };
    this.tabs.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-qv3-explorer-id]');
      if (tab) this.select(tab.dataset.qv3ExplorerId, true);
    });
    this.tabs.addEventListener('keydown', (event) => this.handleKeys(event));
    document.addEventListener('quncel:model-recommendation', (event) => {
      this.recommendation = event.detail;
      this.select(event.detail.primary, false);
    });
    this.renderTabs();
    this.select(this.activeId, false);
  }

  displayName(name) {
    return name.replace(/^Colchón\s+/i, '').replace(/\s+QUNCEL[®™]?$/i, '');
  }

  renderTabs() {
    this.tabs.replaceChildren(...this.products.map((product) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'qv3-explorer__tab';
      button.dataset.qv3ExplorerId = product.id;
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-selected', String(product.id === this.activeId));
      button.innerHTML = '<strong></strong><small></small><em hidden></em>';
      button.querySelector('strong').textContent = this.displayName(product.name);
      button.querySelector('small').textContent = product.territory;
      const marker = button.querySelector('em');
      if (product.id === this.recommendation.primary) { marker.textContent = 'Tu recomendación'; marker.hidden = false; }
      if (product.id === this.recommendation.secondary) { marker.textContent = 'Alternativa'; marker.hidden = false; }
      return button;
    }));
  }

  select(id, focus) {
    const product = this.products.find((item) => item.id === id) || this.products[0];
    const mobileTabs = window.matchMedia('(max-width: 749px)').matches;
    const tabScrollLeft = this.tabs.scrollLeft;
    this.activeId = product.id;
    this.renderTabs();
    if (mobileTabs) this.tabs.scrollLeft = tabScrollLeft;
    this.panel.classList.add('is-changing');
    const image = this.querySelector('[data-qv3-explorer-image]');
    const media = this.querySelector('[data-qv3-explorer-media]');
    image.hidden = !product.image;
    if (product.image) image.src = product.image;
    image.alt = product.image ? this.displayName(product.name) + ' de QUNCEL' : '';
    media.classList.toggle('is-empty', !product.image);
    this.querySelector('[data-qv3-explorer-badges]').innerHTML = product.badgesHtml || '';
    this.querySelector('[data-qv3-explorer-territory]').textContent = product.territory;
    this.querySelector('[data-qv3-explorer-name]').textContent = this.displayName(product.name);
    this.querySelector('[data-qv3-explorer-profile]').textContent = product.profile;
    this.querySelector('[data-qv3-explorer-link]').href = product.url;
    const marker = this.querySelector('[data-qv3-explorer-recommendation]');
    marker.hidden = product.id !== this.recommendation.primary && product.id !== this.recommendation.secondary;
    marker.textContent = product.id === this.recommendation.primary ? 'Tu recomendación' : 'Alternativa';
    this.querySelector('[data-qv3-explorer-facts]').replaceChildren(...product.facts.map((fact) => {
      const item = document.createElement('div');
      item.className = 'qv3-explorer__fact';
      const label = document.createElement('span');
      const value = document.createElement('strong');
      label.textContent = fact.label;
      value.textContent = fact.value;
      item.append(label, value);
      return item;
    }));
    const priceWrap = this.querySelector('[data-qv3-explorer-price-wrap]');
    const comparePrice = this.querySelector('[data-qv3-explorer-compare-price]');
    priceWrap.hidden = !product.price;
    this.querySelector('[data-qv3-explorer-price]').textContent = product.price || '';
    comparePrice.hidden = !product.compareAtPrice;
    comparePrice.textContent = product.compareAtPrice ? product.compareAtPrice + ' €' : '';
    requestAnimationFrame(() => this.panel.classList.remove('is-changing'));
    const selectedTab = this.tabs.querySelector('[aria-selected="true"]');
    if (mobileTabs) {
      // Rebuilding tabs must not hide the active model or move the page vertically.
      if (focus) selectedTab.focus({ preventScroll: true });
      const tabBox = selectedTab.getBoundingClientRect();
      const trackBox = this.tabs.getBoundingClientRect();
      if (tabBox.left < trackBox.left + 9 || tabBox.right > trackBox.right - 9) {
        // Align with a snap point; a minimal right-edge shift can snap back
        // to the preceding model on narrow screens.
        this.tabs.scrollTo({ left: this.tabs.scrollLeft + tabBox.left - trackBox.left - 9, behavior: 'instant' });
      }
    } else if (focus) selectedTab.focus();
  }

  handleKeys(event) {
    const current = event.target.closest('[data-qv3-explorer-id]');
    if (!current || !['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    const ids = this.products.map((product) => product.id);
    let index = ids.indexOf(current.dataset.qv3ExplorerId);
    if (event.key === 'Home') index = 0;
    else if (event.key === 'End') index = ids.length - 1;
    else index = (index + (event.key === 'ArrowDown' || event.key === 'ArrowRight' ? 1 : -1) + ids.length) % ids.length;
    this.select(ids[index], true);
  }
}

if (!customElements.get('quncel-model-explorer')) customElements.define('quncel-model-explorer', QuncelModelExplorer);
